import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Clock, LogIn } from 'lucide-react';

/**
 * Blocking notice shown in place of an outlet/visit form when the user's day is
 * not open. `reason` comes from useAttendanceGate.
 */
const AttendanceGate = ({ reason, punchOutTime, action = 'this entry' }) => {
  const navigate = useNavigate();
  const closed = reason === 'punched-out';

  return (
    <div
      className="max-w-md mx-auto text-center bg-white border border-slate-200 rounded-xl p-8 space-y-4"
      data-testid="attendance-gate"
    >
      <div className={`w-14 h-14 mx-auto rounded-full flex items-center justify-center ${closed ? 'bg-slate-100' : 'bg-amber-100'}`}>
        {closed
          ? <Clock className="w-7 h-7 text-slate-500" />
          : <LogIn className="w-7 h-7 text-amber-600" />}
      </div>

      <div className="space-y-1">
        <h2 className="text-lg font-semibold text-slate-900">
          {closed ? 'Your day is closed' : 'Punch in to start your day'}
        </h2>
        <p className="text-sm text-slate-500">
          {closed
            ? `You punched out${punchOutTime ? ` at ${punchOutTime}` : ''}, so you cannot record ${action} any more today. Punch in again tomorrow.`
            : `You need to punch in before you can record ${action}.`}
        </p>
      </div>

      <div className="flex gap-2 justify-center pt-2">
        <Button variant="outline" onClick={() => navigate(-1)}>Go back</Button>
        {!closed && (
          <Button onClick={() => navigate('/attendance')} className="bg-sky-600 hover:bg-sky-700">
            Go to Attendance
          </Button>
        )}
      </div>
    </div>
  );
};

export default AttendanceGate;
